import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import Chart from "react-apexcharts";
import { format } from "date-fns";
import { getAppMetricsData } from "../../../../../api";
import useDashboardStore from "../../../../stores/dashboard";

const PortfolioVolume = () => {
  const filterDataStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterDataEndDate = useDashboardStore((s) => s.filterData.endDate);

  const filterUser = useDashboardStore((s) => s.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterOrg);

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
    },
    colors: [
      "#44AE42",
      "#819FEC",
      "#7FCECE",
      "#F0BE74",
      "#E7B8DF",
      "#FF4F4F",
      "#660000",
    ],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.3,
        gradientToColors: ["#4C70EF"],
        opacityFrom: 0.4,
        opacityTo: 0,
      },
    },
    grid: {
      borderColor: "#EDEDED",
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        formatter: (value) => `${value} ${new Date().getFullYear()}`,
        style: {
          colors: "#888",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => `$ ${value}`,
        style: {
          colors: "#888",
        },
      },
      // min: 420,
      // max: 520,
    },
    legend: {
      show: false,
      position: "bottom",
      horizontalAlign: "left",
      fontSize: "12px",
      fontFamily: "Work Sans",
      fontWeight: 400,

      labels: {
        colors: "#666",
      },
    },
    dataLabels: {
      enabled: false,
    },
  });
  const [series, setSeries] = useState([]);

  // const chartOptions = ;

  // const series = [
  //   {
  //     name: "Sales",
  //     data: [478, 470, 480, 510, 380, 450, 470, 480, 510, 380, 450, 470],
  //   },
  //   {
  //     name: "Chargebacks",
  //     data: [430, 435, 445, 440, 438, 430, 435, 445, 440, 438, 430, 435],
  //   },
  //   {
  //     name: "Refunds",
  //     data: [425, 428, 430, 429, 431, 425, 428, 430, 429, 431, 425, 428],
  //   },
  // ];

  useEffect(() => {
    // getAppMetricsData({
    //   startDate: format(new Date(filterDataStartDate), "M/d/yyyy"),
    //   endDate: format(new Date(filterDataEndDate), "M/d/yyyy"),
    //   user_id: filterUser,
    //   org_id: filterOrg,
    //   selectedStatuses: [
    //     {
    //       name: "Approved",
    //       id: 12,
    //       color: "#44AE42",
    //       avgPerc: 0,
    //     },
    //     {
    //       name: "Pre-Bank Review",
    //       id: 8,
    //       color: "#819FEC",
    //       avgPerc: 0,
    //     },
    //     {
    //       name: "Underwriting Review",
    //       id: 9,
    //       color: "#7FCECE",
    //       avgPerc: 0,
    //     },
    //     {
    //       name: "In Consideration",
    //       id: 10,
    //       color: "#F0BE74",
    //       avgPerc: 0,
    //     },
    //     {
    //       name: "Awaiting Reserve",
    //       id: 11,
    //       color: "#E7B8DF",
    //       avgPerc: 0,
    //     },
    //     {
    //       name: "Denied",
    //       id: 13,
    //       color: "#FF4F4F",
    //       avgPerc: 0,
    //     },
    //     {
    //       name: "Cancelled",
    //       id: 14,
    //       color: "#660000",
    //       avgPerc: 0,
    //     },
    //   ],
    // }).then((res) => {
    //   console.log("getAppMetricsData", res);
    //   setChartOptions({
    //     ...chartOptions,
    //     xaxis: {
    //       categories: res.categories,
    //     },
    //   });
    //   setSeries(res.series);
    // });
  }, [filterDataStartDate, filterDataEndDate, filterUser, filterOrg]);

  return (
    <div className={styles.portfolioVolume}>
      <div className={styles.portfolioVolumeHeader}>
        <div className={styles.portfolioVolumeHeaderLeft}>
          <h2 className={styles.portfolioVolumeTitle}>Portfolio Volume</h2>
          <p className={styles.portfolioVolumeDescription}>
            {filterDataStartDate} - {filterDataEndDate}
          </p>
        </div>
        <div className={styles.portfolioVolumeHeaderRight}>
          <SlidingTab options={["Volume", "Count"]} onChange={() => {}} />
        </div>
      </div>

      <div className={styles.portfolioVolumeChart}>
        <Chart
          options={chartOptions}
          series={series}
          type="area"
          height={335}
          // width={1110}
        />
      </div>
    </div>
  );
};

export default PortfolioVolume;
